import { useTranslation } from 'react-i18next';
import { useOrderByColumnTextName } from '../hooks/useOrderByColumnTextName';
import { IOrderByAnnouncedProps } from './OrderByAnnounced';

export const useSearchListOrderAnnouncedText = ({
  allColumnList,
  orderBy,
}: IOrderByAnnouncedProps) => {
  const textName = useOrderByColumnTextName({ orderBy, allColumnList });

  const [t] = useTranslation('search');

  if (!orderBy || !textName) {
    return;
  }

  if (orderBy.ascending) {
    return textName + ' ' + t('Ascending');
  }
  if (!orderBy.ascending) {
    return textName + ' ' + t('Descending');
  }
};
